// extracted by mini-css-extract-plugin
export default {"container":"FoxTips_container__rb+OD","commentContainer":"FoxTips_commentContainer__Zs4uY"};